import React, { useState } from "react";
import { NavigationStepsCapNoc } from "../../components/navbars/navbar_cap_noc";
import { Row, Col, Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import CoquillesTable from "../../components/counter";
import { API_URL } from "../../url_config";

const ReportingTetraSaeCapNoc = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = () => {
    setIsRefreshing(true);
    setRefreshTrigger((prev) => prev + 1);
    setTimeout(() => {
      setIsRefreshing(false);
    }, 1000);
  };

  return (
    <div style={{
      padding: "20px",
      backgroundColor: "#fff",
      minHeight: "100vh",
    }}>
      <NavigationStepsCapNoc selectedKey="reporting_tetra_sae" />

      <div style={{
        marginTop: "20px",
        marginBottom: "20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "16px",
        paddingBottom: "16px",
        borderBottom: "1px solid #d9d9d9",
      }}>
        <h2 style={{
          margin: 0,
          fontSize: "18px",
          fontWeight: "600",
          color: "#262626",
        }}>
          Reporting Bascule
        </h2>
        <Button
          type="default"
          icon={<ReloadOutlined spin={isRefreshing} />}
          onClick={handleRefresh}
          disabled={isRefreshing}
        >
          Rafraîchir
        </Button>
      </div>

      <Row gutter={[16, 16]} justify="center" align="middle" style={{ textAlign: 'center' }}>
        <Col xs={24} sm={12} lg={6}>
          <CoquillesTable
            title="TETRA BUS"
            url={`${API_URL}/validations/counter/tetra_bus/?ot_tag=cap_noc`}
            labelAll="Nb PO TETRA DSP"
            labelOk="Nb PO TETRA OK"
            labelNok="Nb PO TETRA KO"
            refreshTrigger={refreshTrigger}
            vertical={true}
            disableAutoRefresh={true}
          />
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <CoquillesTable
            title="SAE-TR"
            url={`${API_URL}/validations/counter/po_siel/?ot_tag=cap_noc`}
            labelAll="Nb lignes DSP"
            labelOk="Nb lignes OK"
            labelNok="Nb lignes KO"
            labelExtra="Nb lignes avec IV indispo"
            showExtra={true}
            refreshTrigger={refreshTrigger}
            vertical={true}
            disableAutoRefresh={true}
          />
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <CoquillesTable
            title="AD premiers sortants par ligne"
            url={`${API_URL}/validations/counter/geolocalisation/?ot_tag=cap_noc`}
            labelAll="Nb lignes DSP"
            labelOk="Nb lignes OK"
            labelNok="Nb lignes KO"
            refreshTrigger={refreshTrigger}
            vertical={true}
            disableAutoRefresh={true}
          />
        </Col>

        <Col xs={24} sm={12} lg={6}>
          <CoquillesTable
            title="Tests radio"
            url={`${API_URL}/validations/counter/tests_ad/?ot_tag=cap_noc`}
            refreshTrigger={refreshTrigger}
            vertical={true}
            disableAutoRefresh={true}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ReportingTetraSaeCapNoc;
